import { Component, OnInit,HostListener } from '@angular/core';
import { ServerService } from '../services/server.service';
import { Router } from '@angular/router';
declare var iziToast:any;
import * as Feather from 'feather-icons';
import Swal from 'sweetalert2'
@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.css']
})
export class ShoppingCartComponent implements OnInit {
  dataElements: HTMLCollectionOf<Element>; // Declare dataElements here
cartdata:any=[];
total_price;
total_tax;
grand_total;
tax_percent;
dataslist:any;
edit = false;
reseller_id;
showing = false;
isButtonDisabled: boolean = true;
cache_clear_data: any;
  system_discount_3cx: any;
  reseller_dis_per: any;
  constructor(private router:Router,private serverService: ServerService) { }

  ngOnInit(): void {
    this.getcart()
    this.customers_data();
    const buttonState = localStorage.getItem('buttonState');
    this.dataElements = document.getElementsByClassName('insert_data_ele');
    if(buttonState){
      this.enableButton();
    }
    setTimeout(() => {
      console.log(this.cache_clear_data);
      if(this.cache_clear_data == 1){
        this.isButtonDisabled =true;
        this.showloadingfunction();
        // this.cacheclear();
      }
      if (this.cache_clear_data == 0) {
        this.enableButton();
      }
    }, 1000);
  }
  showloadingfunction(){
    Swal.fire({
      title: 'Clear Browser cache',
      text: "can you press the Windows (Ctrl + SHIFT + R) or Mac (CMD + SHIFT + R)  Button on your Keyboard...!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      // confirmButtonText: 'Yes, close it!',
			// inputValue: val,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          html:
            '<div style="display: flex;justify-content: center;"><div class="pong-loader"></div></div>',
          showCloseButton: false,
          showCancelButton: false,
          showConfirmButton: false,
          focusConfirm: false,
          background: 'transparent',
        });
        
      }
      Swal.close();
    })
  }
  enableButton() {
    // Enable the button and save its state to local storage
    this.isButtonDisabled = false;
    localStorage.setItem('buttonState', 'enabled');
    // localStorage.setItem('buttonState', 'enabled');
  }

  @HostListener('document:keydown', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   // Check if Ctrl + Shift + R is pressed
  //   if (event.ctrlKey && event.shiftKey && event.key === 'R') {
      
  //     // Enable the button and save its state to local storage
  //     const enableButtonComponent = document.querySelectorAll('insert_data_ele');
  //     alert(enableButtonComponent)
  //     if (enableButtonComponent) {
  //       const enableButtonInstance = enableButtonComponent;
  //       enableButtonInstance.enableButton();
  //     }
  //   }
  // }
  handleKeyboardEvent(event: KeyboardEvent) {
    this.cacheclear();
    // Check if Ctrl + Shift + R is pressed
    setTimeout(() => {
    if (event.ctrlKey && event.shiftKey && event.key === 'R') {
      for (let i = 0; i < this.dataElements.length; i++) {
        const element = this.dataElements[i] as HTMLElement;
        // // Perform your desired actions on each element here
        // // For example, you can enable the button inside the element:
        const button = element.querySelector('button');
        if (button) {
          this.enableButton();
        }
      }
    }else if (event.metaKey && event.shiftKey && event.key === 'R') {
      for (let i = 0; i < this.dataElements.length; i++) {
        const element = this.dataElements[i] as HTMLElement;
        // // Perform your desired actions on each element here
        // // For example, you can enable the button inside the element:
        const button = element.querySelector('button');
        if (button) {
          this.enableButton();
        }
      }
    }
    
    }, 1000);
  }

  cacheclear(){

    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');

    data.action = "update_cache_clear";
    data.customer_id = customer_id;
    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      if (response.status == "true") {
        this.isButtonDisabled = false;
      }
      else {

      }
    },
      (error) => {
      });

  }
  customers_data() {

    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    data.action = "contact_flag";
    data.customer_id = customer_id;
    data.customer_state = localStorage.getItem('customer_state');
    data.cms_user_id = localStorage.getItem('cms_user_id');

    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";

    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        this.system_discount_3cx = response.customer_details.system_discount_3cx;
        this.reseller_dis_per = response.customer_details.reseller_dis_per;
        this.cache_clear_data =response.customer_details.cache_clear_flag;
        console.log(this.cache_clear_data);
        if(this.cache_clear_data == 1){
          this.showloadingfunction();
        }
        if (this.cache_clear_data == 0) {
          this.cacheclear();
      }

      }
      else {

      }
    },
      (error) => {
        console.log(error);
      });

  }
ngAfterViewInit() {
    Feather.replace();
  }

  editid(){
    this.edit = true;



  }

resellerid_change(id){
    // var list_data= this.listDataInfo(data);

// console.log(this.serverService.ci)
  let datas:any =new Object();
 let datasend:any = new Object();
    let access_token: any=localStorage.getItem('at');
    let customer_id: any=localStorage.getItem('en');
   
   
datas.action="reseller_id_change";
datas.customer_id = customer_id;
datas.new_reseller_id = this.reseller_id;



 datasend.access_token=access_token;
  datasend.operation="curlDatas";
  datasend.moduleType="payment";
  datasend.api_type="web";
  datasend.element_data = datas;
      this.serverService.sendServer(datasend).subscribe((response: any) => {
console.log(response)
        if(response.status=="true"){
    
        iziToast.success({
          message: "Reseller ID changed",
          position: 'topRight'
      });
         // this.getcart()
          }
        else{
  iziToast.error({
          message: "Please try again later",
          position: 'topRight'
      });
 
      }

      
      }, 
      (error)=>{
          console.log(error);
      });

}



procedd(){
var s = this;
  iziToast.question({
    timeout: 20000,
    close: false,
    overlay: true,
    displayMode: 'once',
    id: 'question',
    zindex: 999,
    title: 'Confirm',
    message: 'Are you sure? The above reseller id is your 3cx reseller id?',
    position: 'center',
    buttons: [
        ['<button><b>YES</b></button>', function (instance, toast) {
 
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
 console.log('yes')

   s.proceedtobuy()
 

        }, true],
        ['<button>NO</button>', function (instance, toast) {
 
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
  console.log('no')

        }],
    ]

});

}









removecart(data){
    // var list_data= this.listDataInfo(data);

// console.log(this.serverService.ci)
  let datas:any =new Object();
 let datasend:any = new Object();
    let access_token: any=localStorage.getItem('at');
    let customer_id: any=localStorage.getItem('en');
   
   
datas.action="remove_cart";
datas.customer_id = customer_id;
datas.select_chk = data.cart_details_id;



// invoicedata.limit = list_data.limit;
// invoicedata.offset = list_data.offset;
 datasend.access_token=access_token;
  datasend.operation="curlDatas";
  datasend.moduleType="login";
  datasend.api_type="web";
  datasend.element_data = datas;
      this.serverService.sendServer(datasend).subscribe((response: any) => {
console.log(response)
        if(response.status=="true"){
    
        iziToast.success({
          message: "Product removed from your cart",
          position: 'topRight'
      });
         this.getcart()
          }
        else{
  iziToast.error({
          message: "Please try again later",
          position: 'topRight'
      });
 
      }

      
      }, 
      (error)=>{
          console.log(error);
      });

}

proceedtobuy(){
  if(this.cartdata.length != 0){
   this.router.navigate(['/shoppingcartdetails']);

  }else{
      iziToast.error({
          message: "Please add any product in your cart",
          position: 'topRight'
      });
  }
}



getcart(){
  Swal.fire('Please wait')
Swal.showLoading()
  let datas:any =new Object();
 let datasend:any = new Object();
    let access_token: any=localStorage.getItem('at');
    let customer_id: any=localStorage.getItem('en');
   
   
datas.action="getcartlist";
datas.customer_id = customer_id;

 datasend.access_token=access_token;
  datasend.operation="curlDatas";
  datasend.moduleType="login";
  datasend.api_type="web";
  datasend.element_data = datas;
      this.serverService.sendServer(datasend).subscribe((response: any) => {
console.log(response)
        if(response.status=="true"){
          this.showing = true
     this.cartdata = response.options
this.total_price = response.total_price_all
this.total_tax = response.total_tax_value
this.grand_total = response.grand_total_value
this.dataslist = response;
this.tax_percent = response.tax_percent;
this.reseller_id = response.Customer_3cx_data.Resellerid;
localStorage.setItem('xtt', response.tax_percent);


      Swal.close();
          }
        else{
this.cartdata =[];
this.total_tax  ="0.00" 
this.dataslist ="";
    Swal.close();
        }
//    this.offset_count = list_data.offset;
//         this.paginationData = this.serverService.pagination({'offset':response.Offset, 'total':response.Total, 'page_limit' :this.pageLimit });
//          console.log(this.paginationData);
//                 this.recordNotFound = this.prepaidnotedata.length == 0 ? true : false;


      
      }, 
      (error)=>{
          console.log(error);
      });

}








}
